import {
  Button,
  IconButton,
  ListItemButton,
  ListItemButtonProps,
  ListItemSecondaryAction,
  ListItemText,
  Skeleton
} from '@mui/material'
import { Asset } from '../types'
import { useTranslation } from 'react-i18next'
import AssetLevelEditButton from './AssetLevelEditButton'

export interface AssetLevelListItemButtonProps extends Omit<ListItemButtonProps, 'children'> {
  asset: Asset
  editable?: boolean
  afterUpdate?: (asset: Asset) => void
}

export default function AssetLevelListItemButton({
  asset,
  editable = false,
  afterUpdate,
  ...props
}: AssetLevelListItemButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('asset')

  return (
    <ListItemButton {...props}>
      <ListItemText
        primary={
          asset?.level ? (
            asset.level.name
          ) : asset?.levelId === null ? (
            t('noLevel')
          ) : (
            <Skeleton variant="text" width={100} height={20} />
          )
        }
        primaryTypographyProps={{
          color: asset?.levelId === null ? 'text.disabled' : 'inherit'
        }}
        secondary={t('level')}
      />

      {editable && (
        <ListItemSecondaryAction>
          <AssetLevelEditButton
            asset={asset}
            component={asset?.levelId === null ? Button : IconButton}
            variant="outlined"
            afterUpdate={afterUpdate}
          />
        </ListItemSecondaryAction>
      )}
    </ListItemButton>
  )
}
